import { createRouter, createWebHistory } from "vue-router";
import dashboard from "./layouts/dashboardDefault.vue";
import dashboardNoMenu from "./layouts/dashboardNoMenu.vue";
import pdvLayout from "./features/pdv/layouts/pdvLayout.vue";
import { useGlobalStore } from "./store/global.js";
import axios from "axios";
import mixCommons from "./mixins/mixCommons";

const routes = [
  { path: "/", 
    component: () => import("./pages/BistroDashboardV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/login",
    component: () => import("./pages/BistroLogin.vue"),
    meta: {
      requiresNoAuth: true,
    },
  },
  {
    path: "/automaticLogin",
    component: () => import("./pages/AutomaticLogin.vue"),
    meta: {
      requiresNoAuth: true,
    },
  },
  {
    path: "/billViewer",
    component: () => import("./pages/billViewer.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/ticketsViewer",
    component: () => import("./pages/ticketsViewer.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/dashboard/indexV2",
    component: () => import("./pages/BistroDashboardV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard",
    component: () => import("./pages/BistroDashboardV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report",
    component: () => import("./pages/dashboard/report/indexReports.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/integrations",
    component: () => import("./features/integrations/pages/IntegrationsView.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/reportesBI",
    component: () => import("./pages/dashboard/ReportesBI.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/reportesBI/:dashboardId",
    component: () => import("./pages/dashboard/DashboardView.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/reportPDV",
    component: () => import("./pages/dashboard/report/IndexReportsPDV.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/box",
    component: () => import("./pages/dashboard/report/BoxReports.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/sales",
    component: () => import("./pages/dashboard/report/RankingSales.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/salesSupersetBI",
    component: () => import("./pages/dashboard/report/RankingSalesSupersetBI.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/dailyRankingSales",
    component: () => import("./pages/dashboard/report/DailyRankingSales.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/days",
    component: () => import("./pages/dashboard/report/ReportDays.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/month",
    component: () => import("./pages/dashboard/report/ReportMonth.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/transactionDetailReport",
    component: () => import("./pages/dashboard/report/TransactionDetailReport.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/additionals",
    component: () => import("./pages/dashboard/report/AdditionalsReport.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/stockMonthlyReport",
    component: () => import("./pages/dashboard/report/StockMonthlyReport.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/comboSalesReport",
    component: () => import("./pages/dashboard/report/ComboSalesReport.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/waiterReport",
    component: () => import("./pages/dashboard/report/WaiterReport.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/report/MenuProfitabilityReport",
    component: () => import("./pages/dashboard/report/MenuProfitabilityReport.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/billingDetail",
    component: () => import("./pages/dashboard/BillingDetail.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/productsV2",
    component: () => import("./pages/BistroProducts.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/productsPDV",
    component: () => import("@/features/pdvProducts/pages/BistroProductsPDV.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/menuEngineering",
    component: () => import("./pages/BistroMenuEngineering.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/box",
    component: () => import("./pages/BistroBox.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/eventsV2",
    component: () => import("./pages/EventsV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/password",
    component: () => import("./pages/Password.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/settingsV2",
    component: () => import("./pages/SettingsV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/myPayments",
    component: () => import("./features/myPayments/pages/MyPayments.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/myAccount",
    component: () => import("./features/myAccount/pages/MyAccount.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/clientsV2",
    component: () => import("./pages/BistroClientsV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/usersV2",
    component: () => import("./pages/BistroUsersV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/usersDetailsV2",
    component: () => import("./pages/usersDetailsV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/clientsDetailsV2",
    component: () => import("./pages/ClientsDetailsV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/providersV2",
    component: () => import("./pages/BistroProvidersV2.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/dashboard/consolidatedV2",
    component: () => import("./pages/BistroConsolidated"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/dashboard/consolidatedPos",
    component: () => import("./features/pdvConsolidated/pages/BistroConsolidatedPos.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboard,
    },
  },
  {
    path: "/pdv/orders",
    component: () => import("./features/pdv/pages/PdvMain.vue"),
    meta: {
      requiresAuth: true,
      layout: pdvLayout,
    },
  },
  {
    path: "/pdv/order/checkout/:shopcode/:id",
    component: () => import("./features/pdv/pages/PdvOrderCheckout.vue"),
    meta: {
      requiresAuth: true,
      layout: pdvLayout,
    },
  },
  {
    path: "/pdv/order/details/:shopcode/:id",
    component: () => import("./features/pdv/pages/PdvOrderDetails.vue"),
    meta: {
      requiresAuth: true,
      layout: pdvLayout,
    },
  },
  {
    path: "/settingsPos",
    component: () => import("./features/pdv/pages/SettingsPos.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/boxPos",
    component: () => import("./features/pdvBox/pages/BoxPos.vue"),
    meta: {
      requiresAuth: true,
      layout: dashboardNoMenu,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/", // Redirige al inicio
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const store = useGlobalStore();
  const mix = mixCommons.methods;
  if (!store.getAuthUser) {
    try {
      // const response = await axios.post("/api/auth/getCurrentUserData", {});
      let response = localStorage['currentUserData'];
      if (navigator.onLine) {
        response = await axios.post("/api/auth/getCurrentUserData", {});
        localStorage['currentUserData'] = JSON.stringify(response.data)
      }
      store.SET_USER(response.data);
      
      // Inicializar Sentry si el usuario tiene rol PosAdministration
      if (window.initSentryForPosAdmin) {
        window.initSentryForPosAdmin(store);
      }
      //MIGRATION
      if (to.fullPath.includes("/login") && store.getAuthUser && to.query?.username) //Si esta yendo al login y tengo informacion de la sesion
      {
        const decodedUsername = decodeURIComponent(atob(to.query?.username));

        if (decodedUsername != store.getAuthUser.user.name) {
          axios
            .get("/api/auth/logout") /// OK
            .then(() => {
              mix.resetUser();
              mix.setAutomaticLogin(false);
              mix.resetPeriodSelection();
            });
          redirect(null);
        }
        else //END MIGRATION
          redirect(response.data);
      }
      else
        redirect(response.data);
    } catch (error) {
      console.error("[AUTH] Error al cargar los datos del usuario:", error);
      redirect(null);
    }
  } else {
    redirect(true);
  }

  function redirect(access) {
    if (to.path === "/" || (to.meta.requiresAuth && access === null)) {
      next("/login");
    } else if (
      to.meta.requiresNoAuth &&
      access != null &&
      store.getAuthUser.roles.includes("PosAdministration")
    ) {
      next("/pdv/orders");
    } else if (to.meta.requiresNoAuth && access != null) {
      const hasToShowPosAdmin = store.getAuthUser?.roles?.includes("PosAdministration")
      hasToShowPosAdmin ? next("/productspdv") : next("/productsV2")
      // next("/dashboard/indexV2");
    } else {
      next();
    }
  }
});

export default router;
